import { render, staticRenderFns } from "./MyOrdersIndex.vue?vue&type=template&id=20084294&"
import script from "./MyOrdersIndex.vue?vue&type=script&lang=js&"
export * from "./MyOrdersIndex.vue?vue&type=script&lang=js&"
import style0 from "./MyOrdersIndex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports